<template>
  <DialogFormWrapper>
    <template #form>
      <v-form
        id="driverDistanceForm"
        ref="driverDistanceForm"
        v-model="isFormValid"
        class="custom-form pt-6"
        @submit.prevent="submitDistanceForm"
      >
        <v-col cols="12">
          <v-text-field
            v-model="distanceKm"
            outlined
            label="Przejechane kilometry"
            placeholder="Wpisz liczbę kilometrów"
            suffix="km"
            :rules="[rules.required, rules.number, nonNegative, rules.integer]"
          />
        </v-col>
      </v-form>
    </template>
    <template #submit>
      <v-btn color="primary" class="base-hover" :loading="isProcessing" type="submit" form="driverDistanceForm">
        Zapisz kilometry
      </v-btn>
    </template>
  </DialogFormWrapper>
</template>

<script>
import DialogFormWrapper from './Partials/DialogFormWrapper'
import rules from '../../utils/validators'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    DialogFormWrapper
  },
  props: {
    driverId: {
      type: Number,
      required: true
    },
    month: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      rules,
      distanceKm: null,
      isFormValid: true
    }
  },
  computed: {
    ...mapState({
      day: state => state.layout.dialog.item,
      isProcessing: state => state.driversDetails.isProcessing
    })
  },
  created() {
    const distance = this.day?.distanceKm
    if (distance != null) this.distanceKm = String(Number(distance)).replace('.', ',')
  },
  methods: {
    ...mapActions({
      updateDailyDistance: 'driversDetails/updateDailyDistance',
      closeDialog: 'layout/closeDialog'
    }),
    nonNegative(value) {
      const number = Number(String(value).replace(',', '.'))
      if (!Number.isFinite(number)) return true
      return number >= 0 || 'Wartość nie może być ujemna'
    },
    submitDistanceForm() {
      this.$refs.driverDistanceForm.validate()
      if (!this.isFormValid) return

      this.updateDailyDistance({
        driverId: this.driverId,
        month: this.month,
        date: this.day.date,
        distanceKm: this.distanceKm
      }).then(() => {
        this.closeDialog()
      })
    }
  }
}
</script>
